import { render, staticRenderFns } from "./CalmWait.vue?vue&type=template&id=367cfab0&scoped=true&"
import script from "./CalmWait.vue?vue&type=script&lang=js&"
export * from "./CalmWait.vue?vue&type=script&lang=js&"
import style0 from "./CalmWait.vue?vue&type=style&index=0&id=367cfab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367cfab0",
  null
  
)

export default component.exports